export const ContractStatus = {
  PendingSignature: 0,
  UnderReview: 1,
  UnderAverbacao: 2,
  Paid: 3,
  Cancelled: 4,
} as const;

export type ContractStatus = (typeof ContractStatus)[keyof typeof ContractStatus];

export const CONTRACT_STATUS_LABEL: Record<ContractStatus, string> = {
  [ContractStatus.PendingSignature]: 'Aguardando assinatura',
  [ContractStatus.UnderReview]: 'Em análise',
  [ContractStatus.UnderAverbacao]: 'Em averbação',
  [ContractStatus.Paid]: 'Pago',
  [ContractStatus.Cancelled]: 'Cancelado',
};

export const CONTRACT_STATUS_FLOW: ContractStatus[] = [
  ContractStatus.PendingSignature,
  ContractStatus.UnderReview,
  ContractStatus.UnderAverbacao,
  ContractStatus.Paid,
];

export type ContractType = {
  id: string;
  status: ContractStatus;
  cancel_reason?: string;
  negotiated_amount: number;
  installment_value: number;
  installment_count: number;
  created_date: string;
};
